import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CustomerSearchResult } from 'src/app/core/models/customer-search-result';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { AppData } from 'src/app/app.data';


@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss']
})
export class SearchResultComponent implements OnInit {

  settings: Settings;

  @Input() result: CustomerSearchResult;
  @Output() select = new EventEmitter<CustomerSearchResult>();

  hasPermission: boolean;

  constructor(private authService: AuthenticateService, private appSettings: AppSettings, private appData: AppData) { 
    this.hasPermission = authService.claims.CanEditConfidentialPatients;
    this.settings = appSettings.settings;

  }

  ngOnInit() {
  }

  onSelect(event){
    // set patient in appData
    this.appData.patient = { Name: this.result.Name, ID: this.result.EntityID, Email: this.result.Email } ;
    // search-result-component
    this.select.emit(this.result);

  }

  canWatchConfidential(){
    if(this.hasPermission){
      return true;
    } else {
      return !this.result.IsConfidential;
    }
    
  }

  

}
